/**
 * The countries supported in this system.
 *
 * Adding a country here makes it available as a country to associate with a Court System.
 *
 * When adding a country check its ISO 3166 code and name here https://en.wikipedia.org/wiki/List_of_ISO_3166_country_codes
 */
export const SUPPORTED_COUNTRIES = [
    { code: 'au', name: 'Australia', stateLabelCaption: 'State / Territory', hasStates: true },
    { code: 'bs', name: 'Bahamas', stateLabelCaption: 'State', hasStates: false },
    { code: 'ca', name: 'Canada', stateLabelCaption: 'Province / Territory', hasStates: true },
    { code: 'ie', name: 'Ireland', stateLabelCaption: 'Province', hasStates: true },
    { code: 'gb', name: 'United Kingdom', stateLabelCaption: 'Country', hasStates: true },
    { code: 'us', name: 'United States of America', stateLabelCaption: 'State', hasStates: true },
];
